"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import "../util/auth";
import React from "react";
import Account from "../api/account";
const StaffBar = React.createClass({
  propTypes: {
    location: React.PropTypes.object,
    useIntervalReloader: React.PropTypes.bool,
    currentUser: React.PropTypes.object,
    loggedIn: React.PropTypes.bool,
    showV3ReskinTopLevelCheckbox: React.PropTypes.bool,
    toggleV3ReskinTopLevel: React.PropTypes.func,
    v3ReskinTopLevelEnabled: React.PropTypes.bool
  },
  componentDidMount: function() {
    if (this.props.useIntervalReloader) {
      this.interval = setInterval(() => {
        this.setState({
          windowLocation: window.location
        });
      }, 500);
    }
  },
  componentWillUnmount: function() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  getInitialState: function() {
    const initialState = {
      visible: true
    };
    if (this.props.useIntervalReloader) {
      initialState.windowLocation = window.location;
    }
    return initialState;
  },
  isVisible() {
    return this.state.visible && this.props.loggedIn && this.props.currentUser && this.props.currentUser.internal;
  },
  render: function() {
    if (this.isVisible()) {
      return /* @__PURE__ */ React.createElement("div", { className: "staff-bar-container" }, /* @__PURE__ */ React.createElement("nav", { className: "staff-bar" }, /* @__PURE__ */ React.createElement("ul", null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("span", { className: "staff-bar-header", "data-tooltip": true, "aria-haspopup": "true", title: "The Staff Bar is only seen by internal users" }, "Staff Bar")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { onClick: this.hideStaffBar, title: "Hide the Staff Bar until the page is refreshed. Useful for taking screenshots." }, "Hide")), /* @__PURE__ */ React.createElement("li", null, "Share Page", /* @__PURE__ */ React.createElement("a", { className: "icon-copy", onClick: this.copyShareableLinksToClipboard })), /* @__PURE__ */ React.createElement("li", null, "|"), /* @__PURE__ */ React.createElement("li", { title: this.accountTooltip() }, this.accountName()), /* @__PURE__ */ React.createElement("li", null, "|"), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, "Admin Pages:")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: "/admin" }, "Dashboard")), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: this.accountAdminHref(), target: "_blank" }, "Account")), this.possibleResourceLinks(), this.environmentUrls().map((env) => {
        return [
          /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, env.name, ":")),
          /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: env.loginUrl, target: "_blank" }, "Login")),
          /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("a", { href: env.pageUrl, target: "_blank" }, "Page"))
        ];
      }), this.v3ReskinToggles())));
    } else {
      return /* @__PURE__ */ React.createElement("div", null);
    }
  },
  hideStaffBar: function() {
    this.setState({ visible: false });
  },
  copyShareableLinksToClipboard: function() {
    const accountAlias = this.props.currentUser.account.alias;
    const siteUrl = this.getWindowLocation().origin;
    const signInAsUrl = `${siteUrl}/l/${accountAlias}`;
    const currentPageUrl = this.getWindowLocation().href;
    navigator.clipboard.writeText(`${signInAsUrl}?next=${currentPageUrl}`);
  },
  accountAdminHref() {
    return "/admin/accounts/" + this.props.currentUser.account.id;
  },
  accountName() {
    return this.props.currentUser.account.name;
  },
  accountTooltip() {
    const account = this.props.currentUser.account;
    return `Id: ${account.id}
Alias: ${account.alias}
TMS: ${account.tms}`;
  },
  getLocation() {
    let location = this.props.location;
    if (!location) {
      location = { pathname: this.getWindowLocation().pathname, query: {} };
    }
    return location;
  },
  getWindowLocation: function() {
    if (this.state.windowLocation) {
      return this.state.windowLocation;
    } else {
      return window.location;
    }
  },
  possibleResourceLinks() {
    const adminResources = [];
    const location = this.getLocation();
    function extractIdRoute(routePrefix, adminResource, entityName) {
      const regex = new RegExp(routePrefix + "\\/(\\d+)");
      const match = location.pathname.match(regex);
      if (match) {
        adminResources.push({
          href: "/admin/" + adminResource + "/" + match[1],
          text: entityName
        });
        return true;
      }
    }
    if (!extractIdRoute("email", "email_messages", "Email")) {
      const emailId = location.query["emailId"];
      if (emailId) {
        adminResources.push({
          href: "/admin/email_messages/" + emailId,
          text: "Email Message"
        });
      }
    }
    extractIdRoute("index-document-batches", "document_batches", "Document Batch");
    extractIdRoute("loads", "load_states", "LoadState");
    extractIdRoute("carrier_invoices", "carrier_invoices", "Invoice");
    extractIdRoute("factor_invoices", "factor_invoices", "Invoice");
    extractIdRoute("customers", "tms_customers", "Customer");
    extractIdRoute("customer_invoicing/invoices", "customer_invoices", "Customer Invoice");
    extractIdRoute("client_submission/email/\\d+/invoice", "factor_invoices", "Factor Invoice");
    return adminResources.map((r) => {
      return /* @__PURE__ */ React.createElement("li", { key: r.href }, /* @__PURE__ */ React.createElement("a", { href: r.href, target: "_blank" }, r.text));
    });
  },
  environmentUrls() {
    const hosts = Account.current().environment_urls || {};
    return [
      {
        name: "Staging",
        host: hosts.staging
      },
      {
        name: "Prod",
        host: hosts.production
      }
    ].filter((env) => {
      return env.host && this.getWindowLocation().origin != env.host;
    }).map((env) => {
      const accountAlias = this.props.currentUser.account.alias;
      const loginUrl = `${env.host}/l/${accountAlias}`;
      const pageUrl = `${env.host}${this.getWindowLocation().pathname}${this.getWindowLocation().search}`;
      return __spreadProps(__spreadValues({}, env), {
        loginUrl,
        pageUrl
      });
    });
  },
  v3ReskinToggles() {
    if (this.props.showV3ReskinTopLevelCheckbox) {
      return /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("label", { title: "Toggles top-level reskin: Header, Email Search, Activity, and Help", style: { color: "white", lineHeight: 1 } }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          onChange: this.props.toggleV3ReskinTopLevel,
          checked: this.props.v3ReskinTopLevelEnabled,
          style: { margin: "0 5px 0 0", verticalAlign: "middle" }
        }
      ), "V3 Reskin"));
    }
  }
});
export default StaffBar;
